import { render, staticRenderFns } from "./SampleTableTwo.vue?vue&type=template&id=719eb7ae&scoped=true&"
import script from "./SampleTableTwo.vue?vue&type=script&lang=js&"
export * from "./SampleTableTwo.vue?vue&type=script&lang=js&"
import style0 from "./SampleTableTwo.vue?vue&type=style&index=0&id=719eb7ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719eb7ae",
  null
  
)

export default component.exports